// extracted by mini-css-extract-plugin
export var box = "_3w-0";
export var check = "_3w-1";
export var checkboxButton = "_3w-6";
export var checkboxGroup = "_3w-5";
export var disabled = "_3w-7";
export var ghost = "_3w-9";
export var input = "_3w-2";
export var label = "_3w-4";
export var normal = "_3w-8";
export var uncheck = "_3w-3";